import { connect } from 'react-redux'

import SearchResults from './SearchResults'
import { getCurrentUser } from '@src/redux/modules/auth'
import { getUsers } from '@src/redux/modules/entities'

const selector = (state) => {
  const users = getUsers(state)

  const currentUserId = getCurrentUser(state)
  const currentUser = users[currentUserId]

  return {
    secondTimeUser: currentUser && currentUser.servicesCount > 0
  }
}

export default connect(selector)(SearchResults)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/SearchResultsContainer.js